import React, { useEffect, useState } from 'react';
import classes from './../MemberAccount/MemberAccount.css';
import classes1 from './QuickView.css';
import {maskSubscr, getPortalNameForEligibilityScreen, isAccountDisabled, copyToClipboard} from '../../../shared/utility';
import Moment from 'moment';
import QuickViewDiv from './QuickViewDiv';
import AccountStatusQuickViewDiv from './AccountStatusQuickViewDiv';
import {HSID_DELETED, HSID_PERSONAL_REPRESENTATIVE, ID_TYPE_NEW, HSID_PARTIAL_REGISTRATION, QUICK_VIEW_FIELD_IDS, SESSION_SUPERUSER, COPY_SUCCESS_MESSAGE, COPY_FAILURE_MESSAGE, HSID_BASE, SESSION_BASELINEAGENT, BASE_LINE_AGENTS_RESTRICT_DISABLE, BASE_LINE_AGENT_NOT_ALLOWED_MESSAGE, UTC_NAME} from "../../../shared/Constants";
import Message from '../../../components/Message/Message';
import { connect } from 'react-redux';

export const getLastLoginDate = (memberData) => {
    let lastLoginDate = "";
    if(memberData.hsidLastLoginDate){
        lastLoginDate = memberData.hsidLastLoginDate;
    }
    // We should not display the Member DB updated timestamp as last login date as it may not reflect the actual last login.
    // else if(memberData.updateTimestamp){
    //     lastLoginDate = memberData.updateTimestamp.substring(0, memberData.updateTimestamp.indexOf(" "));
    // }
    if(lastLoginDate) {
        lastLoginDate += UTC_NAME;
    }
    return lastLoginDate;
}

export const quickView = (props) => {

        const [copyMessage, setCopyMessage] = useState("");

        const copyToClipBoard = (message) => {
            const v = copyToClipboard(message);
            if (v === true) setCopyMessage(COPY_SUCCESS_MESSAGE);
            else setCopyMessage(COPY_FAILURE_MESSAGE);
        }

        useEffect(() => {
            let isMounted = true;
            if (copyMessage === COPY_SUCCESS_MESSAGE || copyMessage === COPY_FAILURE_MESSAGE) {
                setInterval(() => {
                    if (isMounted) setCopyMessage("");
                }, 2000);
            }
            return () => isMounted = false;
        },[copyMessage]);
    
        let expandCollapeLabel = 'Expand';
        let buttonClass = [classes.collapsible];
        let contentClass = [classes.Content];
        if(props.expanded) {
            contentClass = [classes.Content, classes.ContentExpand];
            expandCollapeLabel='Collapse';

            buttonClass = [classes.collapsible, classes.active];
        }
        let isIdTypePR = props.idType === HSID_PERSONAL_REPRESENTATIVE; 
        let isIdTypeNonMember = props.idType === HSID_PARTIAL_REGISTRATION || (props.idType === HSID_DELETED);
        let idType = ID_TYPE_NEW[props.idType];
        let createDate = props.memberData.createTimestamp ? Moment(props.memberData.createTimestamp).format('YYYY-MM-DD') : "";   
        let dob = props.memberData.mdmDob ? props.memberData.mdmDob : props.memberData.essoData.dob
            dob = dob ? Moment(dob).format('YYYY-MM-DD') : "";

        let whyDisabledReason = "";
        if(props.quickViewDisable && isAccountDisabled(props.memberData.essoData)){
            const incidentTkt = props.memberData.essoData.essoStatus?.note?.indexOf('Identity Confirmation') >-1 ? ' ' : " ("+props.memberData.essoData.essoStatus.incTicket+") "
            if(props.idType === HSID_BASE && props.agentType === SESSION_BASELINEAGENT) {
                whyDisabledReason = BASE_LINE_AGENTS_RESTRICT_DISABLE;
            }else if (props.idType === HSID_BASE) {
                whyDisabledReason = BASE_LINE_AGENT_NOT_ALLOWED_MESSAGE;
            }else if(props.userType===SESSION_SUPERUSER){
                whyDisabledReason = props.memberData.essoData.essoStatus.info+" "+props.memberData.essoData.essoStatus.updatedBy+incidentTkt+props.memberData.essoData.essoStatus.note;
            }else{
                let messageForAgents = props.memberData.essoData.essoStatus.note?.indexOf(" - ") === -1 ? "" : props.memberData.essoData.essoStatus?.note?.slice(props.memberData.essoData.essoStatus?.note?.indexOf(" - "),props.memberData.essoData.essoStatus?.note?.length);
                whyDisabledReason = props.memberData.essoData.essoStatus.info+incidentTkt+ messageForAgents;
            }              
        }  

        let quickViewLeftFields = {
            firstName :{
                name: QUICK_VIEW_FIELD_IDS.firstName,
                value: props.isNullHSID ? props.memberData.mdmFirstNm : props.memberData.essoData.firstName,
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.firstName): true
            },
            lastName :{
                name: QUICK_VIEW_FIELD_IDS.lastName,
                value: props.isNullHSID ? props.memberData.mdmLastNm : props.memberData.essoData.lastName,
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.lastName): true
            },
            idType :{
                name: QUICK_VIEW_FIELD_IDS.idType,
                value: idType,
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.idType): true,
                highlightValue: isIdTypeNonMember || props.isNullHSID || props.isHeadlessUser,
                highlightStyle:{backgroundColor:'yellow', fontWeight:'normal' }
            },
            uuid :{
                name: QUICK_VIEW_FIELD_IDS.uuid,
                value: props.isNullHSID ? '' : (props.memberData.healthSafeId?props.memberData.healthSafeId:props.memberData.essoData.uuid),
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.uuid): true,
            },
            userName :{
                name: QUICK_VIEW_FIELD_IDS.userName,
                value: props.isNullHSID? '' : props.memberData.essoData.userName,
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.userName): true,
            },
            memberId :{
                name: QUICK_VIEW_FIELD_IDS.memberId,
                value: props.memberData.mdmSubscriberId ? maskSubscr(props.memberData.mdmSubscriberId):"",
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.memberId): true,
            },
            hsidCreatedDate :{
                name: QUICK_VIEW_FIELD_IDS.hsidCreatedDate,
                value: isIdTypePR?"":createDate,
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.hsidCreatedDate): true
            }
        }

        let quickViewRightFields = {
            dob :{
                name: QUICK_VIEW_FIELD_IDS.dob,
                value: dob,
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.dob): true
            },
            zip :{
                name: QUICK_VIEW_FIELD_IDS.zip,
                value: props.memberData.mdmZip,
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.zip): true
            },
            recoveryMethod :{
                name: QUICK_VIEW_FIELD_IDS.recoveryMethod,
                value: props.isNullHSID ? '' : (props.memberData.essoData.phone.number?"Phone":"Security Questions"),
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.recoveryMethod): true
            },
            lastLoginDate :{
                name: QUICK_VIEW_FIELD_IDS.lastLoginDate,
                value: props.isNullHSID || isIdTypePR ? "" : getLastLoginDate(props.memberData),
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.lastLoginDate): true
            },
            pwdResetDate :{
                name: QUICK_VIEW_FIELD_IDS.pwdResetDate,
                value: props.isNullHSID ? '' : (props.memberData.essoData.essoStatus.lastPasswordChangeTime ? props.memberData.essoData.essoStatus.lastPasswordChangeTime+UTC_NAME : ""),
                shouldShow : props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.pwdResetDate): true
            },
            hsidRegistrationPortal: {
                name: QUICK_VIEW_FIELD_IDS.hsidRegistrationPortal,
                value: props.memberData.mbrRgstPrtlShrtNm && !isIdTypePR ? getPortalNameForEligibilityScreen(props.memberData.mbrRgstPrtlShrtNm) : "",
                shouldShow: props.viewType? !props.viewType.includes(QUICK_VIEW_FIELD_IDS.hsidRegistrationPortal): true
            }

        }
        return (
            <div className={classes1.QuickView}>
                <div className={classes1.QuickViewHeader}>
                    <div className={classes1.QuickViewHeaderEndsDiv} style={{flexGrow:12}}>
                    </div>
                    <div style={{flexGrow:3}}>
                        <h2 className={classes1.QuickViewTitle}>Quick View</h2>                      
                    </div>
                    <div style={{flexGrow:5,display:'flex', justifyContent:'flex-end'}}>
                        <Message msgType="Success" position="PositionAbsolute" info={{message:copyMessage}} />
                        <button className={classes1.copy_button} onClick={() => {copyToClipBoard("QuickView")}} disabled = {!props.expanded}>Copy</button>
                        <button className={buttonClass.join(' ')} onClick={props.expandHandler}>{expandCollapeLabel}</button>
                    </div>
                </div>
                <React.Fragment>
                <div className={contentClass.join(' ')} id="QuickView">
                    <div className={classes1.QuickViewLeft}>
                    {Object.keys(quickViewLeftFields).map(key => (
                        <QuickViewDiv 
                        key = {key}
                         name={quickViewLeftFields[key].name}
                         value={quickViewLeftFields[key].value}
                         shouldShow={quickViewLeftFields[key].shouldShow}
                         highlightStyle={quickViewLeftFields[key].highlightStyle}
                         highlightValue={quickViewLeftFields[key].highlightValue}
                    >
                    </QuickViewDiv>
                    ))}
                    </div>
                    <div className={classes1.QuickViewRight}>
                    {Object.keys(quickViewRightFields).map(key => (
                        <QuickViewDiv 
                            key = {key}
                         name={quickViewRightFields[key].name}
                         value={quickViewRightFields[key].value}
                         shouldShow={quickViewRightFields[key].shouldShow}
                         highlightStyle={quickViewRightFields[key].highlightStyle}
                         highlightValue={quickViewRightFields[key].highlightValue}
                    >
                    </QuickViewDiv>
                    ))}
                    <div>
                        <AccountStatusQuickViewDiv
                        deleted={props.memberData?.essoData?.accountStatus?.accountDeleted}
                        status={!props.isNullHSID && props.memberData.essoData.essoStatus.enableDisableStatus}
                        toggleQuickView={props.toggleQuickView}
                        isNullHSID={props.isNullHSID}
                        whyDisabledReason={whyDisabledReason}
                        idType={props.idType}
                        member={props.memberData}
                        userType={props.agentType}
                        shouldShow={true}
                        >

                        </AccountStatusQuickViewDiv>
                   
                    </div>
                    </div>
                </div>
                </React.Fragment>
                </div>
        );
}

const mapStateToProps = (state) => {
    return {
        agentType: state.usr.user.userType
    }
}

export default connect(mapStateToProps, null)(quickView);